import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormGroup,
  FormLabel,
  LinearProgress,
  Typography,
  OutlinedInput,
} from "@material-ui/core";

import useLogs from "hooks/logs";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import Api from "lib/api/httpRequestHelper";

export default function FormSolicitarDevolucaoDialog({
  open,
  formType,
  onClose,
  selectedProduct,
  productsList,
  setProductsList,
}) {
  const [reasonsList, setReasonsList] = useState([]);
  const [selectedReason, setSelectedReason] = useState(
    selectedProduct.idMotivo
  );
  const [selectedReasonComplete, setSelectedReasonComplete] = useState();
  const [searchReason, setSearchReason] = useState();

  const [defectList, setDefectList] = useState([]);
  const [selectedDefect, setSelectedDefect] = useState(
    selectedProduct.idDefeito
  );
  const [selectedDefectComplete, setSelectedDefectComplete] = useState();
  const [defectByReason, setDefectByReason] = useState([]);
  const [searchDefect, setSearchDefect] = useState();

  const [quantity, setQuantity] = useState(selectedProduct?.quantidade);

  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const [submitting, setSubmitting] = useState(false);

  const handleGetReasons = async () => {
    setSearchReason(true);
    await Api.get("list-reason", "trocasDevolucoes", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setReasonsList(Result.ListaMotivos);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "191",
          screen: "Motivos de Devolucoes",
          problem: `Erro na chamada do endpoint list-reasons - ${error}`,
        });
      })
      .finally(() => setSearchReason(false));
  };

  const handleGetDefects = async () => {
    setSearchDefect(true);
    await Api.get("list-defect", "trocasDevolucoes", "?page=0", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setDefectList(Result.ListaDefeitos);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "191",
          screen: "Motivos de Defeitos",
          problem: `Erro na chamada do endpoint list-defect - ${error}`,
        });
      })
      .finally(() => setSearchDefect(false));
  };

  const submit = async (values) => {
    let updatedDefect = {};

    setSubmitting(true);

    if (formType === "delete") {
      setSubmitting(true);

      const list = productsList.filter((product) => {
        return product.idProduto !== selectedProduct.idProduto;
      });

      console.log("list", list);

      setProductsList(list);
      setSubmitting(false);
      onClose();
    }

    if (formType === "edit") {
      updatedDefect = {
        idTableProduct: selectedProduct?.idTableProduct,
        idProduto: selectedProduct?.idProduto,
        name: selectedProduct?.name,
        quantidade: quantity,
        idMotivo: selectedReason,
        motivo: selectedReasonComplete?.Motivo,
        idDefeito: selectedDefect || "",
        defeito: selectedDefectComplete?.Defeito || "",
      };

      const list = productsList.map((product) => {
        if (product.idProduto === selectedProduct.idProduto) {
          return updatedDefect;
        }
        return product;
      });

      setProductsList(list);
      setSubmitting(false);
      onClose();
    }

    return;
  };

  useEffect(() => {
    handleGetReasons();
    handleGetDefects();
  }, []);

  useEffect(() => {
    const defectByReason = defectList.filter(
      (defect) => defect.IdMotivo === selectedReason
    );
    setDefectByReason(defectByReason);
  }, [selectedReason, defectList]);

  useEffect(() => {
    setSearchReason(true);
    if (reasonsList.length > 0 && selectedReason) {
      const matchingReason = reasonsList.find(
        (reason) => reason.IdMotivo === selectedReason
      );
      if (matchingReason) {
        setSelectedReasonComplete(matchingReason);
      }
    }
    setSearchReason(false);
  }, [reasonsList, selectedReason]);

  useEffect(() => {
    setSearchDefect(true);
    if (defectByReason.length > 0 && selectedDefect) {
      const matchingDefect = defectByReason.find(
        (defect) => defect.IdDefeito === selectedDefect
      );
      if (matchingDefect) {
        setSelectedDefectComplete(matchingDefect);
      }
    }

    setSearchDefect(false);
  }, [defectByReason, selectedDefect]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        maxWidth={"xl"}
      >
        <PerfectScrollbar>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                {`${formType === "edit" ? "Editar" : "Excluir"} Produto`}
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 0" }}>
              {formType === "delete" ? (
                <>
                  <Typography variant="h4" style={{ marginBottom: "1rem" }}>
                    Confirmar exclusão do Produto?
                  </Typography>
                </>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Produto</FormLabel>
                      <Typography variant="h5" component="p">
                        {selectedProduct.idProduto} - {selectedProduct.name}
                      </Typography>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Quantidade</FormLabel>
                      <OutlinedInput
                        fullWidth
                        type="number"
                        disabled={submitting}
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        inputProps={{ min: 1 }}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container xs={12} spacing={2}>
                      <Grid item xs={6}>
                        <AutoCompleteField
                          label="Motivo de Devolução"
                          onChange={(newValue) => {
                            setSelectedReason(newValue.IdMotivo);
                            setSelectedReasonComplete(newValue);
                          }}
                          loading={searchReason}
                          value={selectedReasonComplete}
                          options={reasonsList}
                          disabled={submitting || searchReason}
                          optionLabelKey="Motivo"
                          optionIdKey="IdMotivo"
                        />
                      </Grid>
                      {defectByReason.length > 0 && (
                        <Grid item xs={6} style={{ paddingRight: "0" }}>
                          <AutoCompleteField
                            label="Motivo de Defeito"
                            onChange={(newValue) => {
                              setSelectedDefect(newValue.IdDefeito);
                              setSelectedDefectComplete(newValue);
                            }}
                            loading={searchDefect}
                            value={selectedDefectComplete}
                            options={defectByReason}
                            disabled={submitting || searchDefect}
                            optionLabelKey="Defeito"
                            optionIdKey="IdDefeito"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {submitting && (
                <div style={{ marginTop: "1rem" }}>
                  <span>{`${
                    formType === "edit" ? "Atualizando" : "Deletando"
                  } Produto...`}</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button component={Box} onClick={onClose} disabled={submitting}>
                Cancelar
              </Button>
              {formType === "delete" ? (
                <Button
                  color="default"
                  variant="contained"
                  type="submit"
                  disabled={submitting}
                  onClick={submit}
                >
                  Confirmar
                </Button>
              ) : (
                <Button
                  color="default"
                  variant="contained"
                  type="submit"
                  disabled={
                    submitting ||
                    !quantity ||
                    !selectedReason ||
                    (defectByReason.length > 0 && !selectedDefect)
                  }
                  onClick={submit}
                >
                  Atualizar
                </Button>
              )}
            </DialogActions>
          </PerfectScrollbar>
        </PerfectScrollbar>
      </Dialog>
    </>
  );
}
